<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-funnel-plot`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46.25 7a1 1 0 00-1-1H2.75a1 1 0 00-.86 1.508l21.249 36.031a1 1 0 001.722 0l21.25-36.031A1 1 0 0046.249 7zM18.618 28H29.38L24 37.126 18.619 28zm16.07-9H13.31l2.95 5h15.48l2.948-5zM8.002 10h31.994l-2.95 5H10.953l-2.95-5z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconFunnelPlot',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
